import { Gondor } from "../Gondor";

const ACTIONS = {
  SCHOOL_GRADE: "/schoolGrade/",
  SCHOOL_GRADE_ITEM: "/schoolGrade/{id}/",
  ADD_SYSTEMS: "/schoolGrade/add/system",
  REMOVE_SYSTEMS: "/schoolGrade/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.SCHOOL_GRADE, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.SCHOOL_GRADE_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.SCHOOL_GRADE, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.SCHOOL_GRADE_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.SCHOOL_GRADE_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
